import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useLoginStore, useUserStore } from 'store';
import { LoginComponent } from 'components';
import { putTermsAgree } from 'apis';

const LoginBaseComponent = () => {
    const { view, setView } = useLoginStore();
    const navigate = useNavigate();

    useEffect(() => {
        const accessToken = localStorage.getItem('user_access_token');
        const termsAgree = localStorage.getItem('terms_agree');

        if (accessToken && termsAgree === 'true') {
            navigate('/');
            return;
        }

        if (!accessToken) {
            setView('login');
        } else if (accessToken && termsAgree !== 'true') {
            // Auto-agree terms and redirect (simplified flow)
            putTermsAgree(true, '2000-01-01')
                .then((response) => {
                    if (response.data.isSuccess === 'T') {
                        localStorage.setItem('terms_agree', 'true');
                        navigate('/');
                    }
                })
                .catch((error) => {
                    console.error('Auto terms agree failed:', error);
                    // Fallback: just set local and redirect
                    localStorage.setItem('terms_agree', 'true');
                    navigate('/');
                });
        }
    }, [navigate, setView]);

    return (
        <div className="flex flex-col bg-white border border-achromatic-100 rounded-2xl gap-16 mobile:rounded-none mobile:border-0">
            <LoginComponent />
        </div>
    );
}

export default LoginBaseComponent;